import { render } from "./PharmaPay.vue?vue&type=template&id=723fea2c&scoped=true&ts=true"
import script from "./PharmaPay.vue?vue&type=script&lang=ts"
export * from "./PharmaPay.vue?vue&type=script&lang=ts"

import "./PharmaPay.vue?vue&type=style&index=0&id=723fea2c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723fea2c"]])

export default __exports__